export default {
  "clientTunnels": "Client Tunnels",
  "outboundOpenVPNTunnelsTheServerDialsThroughActivationIsExclusive": "Outbound OpenVPN tunnels the server dials through (activation is exclusive)",
  "noClientTunnelsUploaded": "No client tunnels uploaded",
  "config": "Config",
  "remote": "Remote",
  "added": "Added",
  "status": "Status",
  "actions": "Actions",
  "active": "Active",
  "inactive": "Inactive",
  "view": "View",
  "deactivate": "Deactivate",
  "activate": "Activate",
  "deleteClientTunnel": "Delete Client Tunnel",
  "thisActionCannotBeUndone": "This action cannot be undone.",
  "errorLoadingOpenVPNStatus": "Error loading OpenVPN status",
  "uploadClientConfig": "Upload Client Config",
  "addOpenVPNOvpnClientConfigurationFiles": "Add OpenVPN .ovpn client configuration files",
  "refresh": "Refresh",
  "upload": "Upload",
  "cLIReference": "CLI Reference",
  "openVPNIsProvisionedAndManagedViaTheQuickBoxCLI": "OpenVPN is provisioned and managed via the QuickBox CLI:",
  "fullOpenVPNDocumentation": "Full OpenVPN documentation",
  "uploadConfig": "Upload Config",
  "activateTunnel": "Activate Tunnel",
  "deactivateTunnel": "Deactivate Tunnel",
  "deleteTunnel": "Delete Tunnel",
  "queued": "Queued",
  "running": "Running",
  "completed": "Completed",
  "failed": "Failed",
  "cancelled": "Cancelled",
  "systemResponse": "System Response",
  "closeDialog": "Close dialog",
  "jobCancelled": "Job cancelled.",
  "operationCompletedSuccessfully": "Operation completed successfully.",
  "operationFailed": "Operation failed.",
  "copyLogs": "Copy logs",
  "close": "Close",
  "clientProfiles": "Client Profiles",
  "perUserOvpnConfigurationsBuiltByTheInstaller": "Per-user .ovpn configurations built by the installer",
  "noClientProfilesFound": "No client profiles found",
  "user": "User",
  "modified": "Modified",
  "size": "Size",
  "opensTheSecureDownloadPromptsForYourQuickBoxPassword": "Opens the secure download (prompts for your QuickBox password)",
  "download": "Download",
  "secureDownloadNotWiredNginxDeliveryConfigMissing": "Secure download not wired (nginx delivery config missing)",
  "notInstalled": "Not installed",
  "stopped": "Stopped",
  "openVPNServer": "OpenVPN Server",
  "builtInOpenVPNServiceStatus": "Built-in OpenVPN service status",
  "subnet": "Subnet",
  "endpoint": "Endpoint",
  "boot": "Boot",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "profiles": "Profiles",
  "all": "All",
  "staged": "Staged",
  "available": "Available",
  "notInstalled2": "Not Installed",
  "filterRoutableAppsByRoutingStatus": "Filter routable apps by routing status",
  "healthy": "Healthy",
  "unknown": "Unknown",
  "degraded": "Degraded",
  "routingIsStagedItWillBecomeFullyActiveTheFirst": "Routing is staged. It will become fully active the first time the app is installed.",
  "stagedAwaitingInstall": "Staged · awaiting install",
  "failedToUpdateKillSwitchSettings": "Failed to update kill switch settings",
  "thisPeerConfigIsCurrentlyInUseByYourMain": "This peer config is currently in use by your main VPN connection. App-scoped routing must use a different WireGuard config.",
  "failedToEnableRouting": "Failed to enable routing",
  "failedToStageRouting": "Failed to stage routing",
  "failedToDisableRouting": "Failed to disable routing",
  "appScopedRouting": "App-Scoped Routing",
  "routeSpecificAppTrafficThroughVPN": "Route specific app traffic through VPN",
  "error": "Error",
  "routeSupportedAppsThroughWireGuard": "Route supported apps through WireGuard",
  "noRoutableServicesFound": "No Routable Services Found",
  "appScopedRoutingIsAvailableForSupportedAppsInstallA": "App-scoped routing is available for supported apps. Install a supported application and ensure its service is running to enable VPN routing.",
  "wireGuardDocumentation": "WireGuard documentation",
  "supportedApps": "supported apps",
  "searchRoutableApplications": "Search routable applications",
  "searchApps": "Search apps...",
  "routableApplications": "Routable applications",
  "noAppsMatch": "No apps match “{{query}}”",
  "noAppsInThisFilter": "No apps in this filter",
  "routingIsStagedAwaitingInstall": "Routing is staged — awaiting install",
  "routingStaged": "Routing staged",
  "notInstalled3": "not installed",
  "serviceInstance": "Service Instance",
  "routeForUser": "Route for user",
  "chooseTheUserThisAppWillBeInstalledForThe": "Choose the user this app will be installed for; the routing profile finalizes when they install it.",
  "tunnelBackend": "Tunnel Backend",
  "tunnelBackend2": "Tunnel backend",
  "openVPNConfig": "OpenVPN Config",
  "wireGuardConfig": "WireGuard Config",
  "selectAConfig": "Select a config...",
  "learnMore": "Learn more",
  "tuning": "Tuning",
  "optional": "Optional",
  "killSwitchStaleThresholdSeconds": "Kill-switch stale threshold (seconds)",
  "default": "default (",
  "directRemoteAccess": "Direct remote access",
  "whenEnabledQuickBoxRoutesInboundConnectionsToPlexThroughYour": "When enabled, QuickBox routes inbound connections to Plex through your seedbox's public IP, bypassing the VPN. Plex's outbound calls (library scans, claim flow, API requests) continue using the VPN. This gives full-bandwidth direct connections for clients while keeping the VPN's privacy benefits for outbound traffic.",
  "whatIsDirectRemoteAccess": "What is direct remote access?",
  "clientsConnectDirectlyToYourSeedboxAtFullBandwidthRecommended": "Clients connect directly to your seedbox at full bandwidth. Recommended for Plex media servers.",
  "clientsCanOnlyConnectThroughPlexRelayBandwidthCappedOr": "Clients can only connect through Plex Relay (bandwidth-capped) or external VPN tunnels.",
  "currentRouting": "Current Routing",
  "backend": "Backend:",
  "config2": "Config:",
  "interface": "Interface:",
  "service": "Service:",
  "lastApplied": "Last Applied:",
  "pendingInstall": "Pending install",
  "notSet": "Not set",
  "directRemoteAccess2": "Direct remote access:",
  "clientsConnectDirectlyToYourPlexServerAtFullBandwidth": "Clients connect directly to your Plex server at full bandwidth. To change, disable and re-enable routing.",
  "clientsConnectThroughPlexRelayBandwidthCappedOrExternalVPN": "Clients connect through Plex Relay (bandwidth-capped) or external VPN tunnels. To change, disable and re-enable routing.",
  "whenEnabledQuickBoxRoutesInboundPlexConnectionsThroughYourSeedbox": "When enabled, QuickBox routes inbound Plex connections through your seedbox's public IP, bypassing the VPN. Plex's outbound calls continue using the VPN. To change this setting, disable and re-enable routing.",
  "kSThreshold": "KS Threshold:",
  "reachingPlexWhileRouted": "Reaching Plex while routed",
  "reachingThisService": "Reaching this service",
  "recommendedReverseProxy": "Recommended — reverse proxy:",
  "port443WorksEvenThroughTheVPN": "(port 443, works even through the VPN)",
  "localNetwork": "Local network:",
  "alsoReachableAtYourServerSLANAddressAndIts": "also reachable at your server's LAN address and its usual port — local connections are always forwarded to the service.",
  "remoteWAN": "Remote (WAN):",
  "useTheReverseProxyURLAboveTheRawServicePort": "use the reverse proxy URL above — the raw service port is not exposed on the public IP while routing is active.",
  "killSwitchProtection": "Kill Switch Protection",
  "triggerAfterStaleHandshakeSeconds": "Trigger after stale handshake (seconds)",
  "autoRecover": "Auto-Recover",
  "automaticallyAttemptToRestoreVPNRoutingAfterTheKillSwitch": "Automatically attempt to restore VPN routing after the kill switch fires. Uses exponential backoff (2m, 4m, 8m, 16m, 30m) with a maximum of 5 attempts.",
  "saving": "Saving...",
  "saveKillSwitchSettings": "Save Kill Switch Settings",
  "whenEnabledFullyStopsTheServiceIfTheVPNConnection": "When enabled, fully stops the service if the VPN connection degrades. Prevents any traffic from leaking outside the VPN tunnel.",
  "killSwitchTriggered": "Kill switch triggered",
  "killSwitchTriggered2": "Kill Switch Triggered",
  "theServiceWasFullyStoppedByTheKillSwitchDue": "The service was fully stopped by the kill switch due to a stale VPN connection. Re-enable routing to restore the service.",
  "autoRecoveryInProgress": "Auto-Recovery in Progress",
  "autoRecoveryExhausted": "Auto-Recovery Exhausted",
  "all5RecoveryAttemptsFailedTheServiceRemainsStoppedManual": "All 5 recovery attempts failed. The service remains stopped. Manual re-enable required.",
  "cancelStaging": "Cancel Staging",
  "disableRouting": "Disable Routing",
  "enabling": "Enabling...",
  "enableRouting": "Enable Routing",
  "staging": "Staging...",
  "stageRouting": "Stage Routing",
  "setUpVPNRoutingNowSoPlexSFirstConnection": "Set up VPN routing now so Plex's first connection goes through the tunnel after install.",
  "howItWorks": "How it works:",
  "appScopedRoutingUsesNetworkNamespacesToIsolateAndRoute": "App-scoped routing uses network namespaces to isolate and route only traffic from the selected service instance through the VPN. All other system traffic uses the default route. The app service must be running for routing to work correctly.",
  "wholeNumberOnly": "Whole number only.",
  "vPNConfigPolicySaved": "VPN config policy saved",
  "failedToSavePolicy": "Failed to save policy",
  "pleaseTryAgain": "Please try again.",
  "configLifecyclePolicy": "Config Lifecycle Policy",
  "howStashedWireGuardConfigsAreAgedProbedAndRetiredApplies": "How stashed WireGuard configs are aged, probed, and retired. Applies to every provider; only NordVPN configs can be auto-regenerated.",
  "loadingVPNConfigPolicy": "Loading VPN config policy…",
  "vPNConfigPolicyIsManagedByTheServerAndCould": "VPN config policy is managed by the server and could not be loaded right now.",
  "livenessProbing": "Liveness probing",
  "runTheBackgroundSweepThatAutomaticallyTracksEachConfigRsquo": "Run the background sweep that automatically tracks each config’s health over time. On-demand “Test now” checks still work when this is off.",
  "stalenessPolicyDays": "Staleness policy (days)",
  "ageAtWhichAConfigIsTreatedAsPastIts": "Age at which a config is treated as past its useful life and flagged for replacement.",
  "agingWarnLeadDays": "Aging warn-lead (days)",
  "howManyDaysBeforeTheStalenessHorizonToStartShowing": "How many days before the staleness horizon to start showing an “Aging” warning.",
  "minHealthyPoolRegion": "Min. healthy pool / region",
  "warnWhenFewerThanThisManyHealthyConfigsRemainFor": "Warn when fewer than this many healthy configs remain for a region.",
  "autoCleanupDeadConfigs": "Auto-cleanup dead configs",
  "automaticallyQuarantineAndRetireConfigsTheProbeConfirmsAreDead": "Automatically quarantine and retire configs the probe confirms are dead. NordVPN configs can then be regenerated; other providers must be re-uploaded manually.",
  "savePolicy": "Save policy",
  "failedToLoadConfig": "Failed to load config",
  "configCopiedToClipboard": "Config copied to clipboard",
  "failedToCopyConfig": "Failed to copy config",
  "copy": "Copy",
  "closeConfigViewer": "Close config viewer",
  "loadingConfig": "Loading config...",
  "invalidFileType": "Invalid file type",
  "fileTooLarge": "File too large",
  "tooManyFiles": "Too many files",
  "browseFiles": "Browse Files",
  "cancel": "Cancel",
  "uploading": "Uploading...",
  "location": "Location",
  "organization": "Organization",
  "ping": "Ping",
  "appRouted": "App Routed",
  "instance": "Instance",
  "vPNConfig": "VPN Config",
  "exitIP": "Exit IP",
  "noActiveVPN": "No Active VPN",
  "activateAPeerConfigToEstablishAVPNConnection": "Activate a peer config to establish a VPN connection.",
  "app": "App",
  "systemVPN": "System VPN",
  "appRoute": "App Route",
  "noActiveConnections": "No active connections",
  "unknownLocation": "Unknown location",
  "date": "Date",
  "peer": "Peer",
  "type": "Type",
  "system": "System",
  "action": "Action",
  "duration": "Duration",
  "noConnectionHistory": "No connection history",
  "connectionHistory": "Connection History",
  "searchPeersLocations": "Search peers, locations...",
  "noConnectionHistoryYet": "No connection history yet",
  "historyIsRecordedWhenVPNPeersAreActivatedOrDeactivated": "History is recorded when VPN peers are activated or deactivated.",
  "activatePeer": "Activate Peer",
  "deactivatePeer": "Deactivate Peer",
  "deletePeer": "Delete Peer",
  "generateNordVPNConfigs": "Generate NordVPN Configs",
  "nordVPNAccessTokenIsRequired": "NordVPN access token is required",
  "pleaseSelectACountry": "Please select a country",
  "nordVPNConfigGenerator": "NordVPN Config Generator",
  "generateWireGuardConfigsFromNordVPNServers": "Generate WireGuard configs from NordVPN servers",
  "generatedConfigsWillAppearInThePeerConfigurationsTableAbove": "Generated configs will appear in the Peer Configurations table above and can be activated like any other WireGuard peer.",
  "nordVPNAccessToken": "NordVPN Access Token",
  "pasteYourNordVPNAccessToken": "Paste your NordVPN access token",
  "yourTokenIsSentSecurelyAndIsNeverStoredOr": "Your token is sent securely and is never stored or logged.",
  "country": "Country",
  "loadingCountries": "Loading countries...",
  "selectACountry": "Select a country",
  "numberOfConfigs": "Number of Configs",
  "onePerUniqueCitySortedByLowestServerLoad": "One per unique city, sorted by lowest server load",
  "dNSServer": "DNS Server",
  "v3CLIEquivalent": "v3 CLI equivalent",
  "reset": "Reset",
  "generating": "Generating...",
  "generateConfigs": "Generate Configs",
  "serverConfig": "Server Config",
  "localHosted": "Local Hosted",
  "theConfigSServerIsPresentInTheLiveProvider": "The config's server is present in the live provider fleet.",
  "aging": "Aging",
  "nearingTheStalenessPolicyRegenerateSoon": "Nearing the staleness policy — regenerate soon.",
  "stale": "Stale",
  "theProviderAppearsToHaveDecommissionedThisServer": "The provider appears to have decommissioned this server.",
  "quarantined": "Quarantined",
  "confirmedDeadScheduledForRemoval": "Confirmed dead — scheduled for removal.",
  "notYetProbedOrNoPositiveLivenessSignal": "Not yet probed, or no positive liveness signal.",
  "justNow": "just now",
  "peerDetails": "Peer Details",
  "name": "Name",
  "org": "Org",
  "health": "Health",
  "theEndpointDidNotAnswerTheLastPingItMay": "The endpoint did not answer the last ping. It may be down, or may simply block ICMP.",
  "unreachable": "Unreachable",
  "inUseAppRoute": "In use · App Route",
  "appRoutes": "App Routes",
  "configPreview": "Config Preview",
  "viewFullConfig": "View Full Config",
  "runALiveLivenessProbeNowAndRefreshThisConfig": "Run a live liveness probe now and refresh this config's health. Active configs use a zero-privilege fleet check; inactive configs are brought up briefly in an isolated namespace.",
  "testNow": "Test now",
  "viewConfig": "View Config",
  "deleteThisPeerConfigPermanently": "Delete this peer config permanently",
  "dateAdded": "Date Added",
  "peerInfo": "Peer Info",
  "dropConfFilesHere": "Drop .conf files here",
  "noPeerConfigurations": "No peer configurations",
  "releaseToAddYourWireGuardConfigFiles": "Release to add your WireGuard config files",
  "uploadWireGuardConfFilesFromAnyProviderToGetStarted": "Upload WireGuard .conf files from any provider to get started",
  "supportsNordVPNMullvadProtonVPNSurfsharkPIAAndAnyWireGuardCompatible": "Supports NordVPN, Mullvad, ProtonVPN, Surfshark, PIA, and any WireGuard-compatible provider",
  "selectWireGuardConfigFiles": "Select WireGuard config files",
  "browseConfigFiles": "Browse Config Files",
  "clear": "Clear",
  "viewDetails": "View Details",
  "collapseDetails": "Collapse details",
  "loadingPeers": "Loading peers...",
  "failedToLoadPeers": "Failed to load peers",
  "copiedToClipboard": "Copied to clipboard",
  "failedToCopy": "Failed to copy",
  "notAvailable": "Not available",
  "hideKey": "Hide key",
  "revealKey": "Reveal key",
  "copyToClipboard": "Copy to clipboard",
  "loadingKeys": "Loading keys...",
  "private": "Private",
  "public": "Public",
  "hideKeys": "Hide Keys",
  "showKeys": "Show Keys",
  "privateKey": "Private Key",
  "publicKey": "Public Key",
  "splitTunnel": "Split tunnel",
  "fullTunnel": "Full tunnel",
  "revokeWireGuardPeer": "Revoke WireGuard peer",
  "revoke": "Revoke",
  "youCanReEnrollThemLaterANewConfigWill": "You can re-enroll them later; a new config will be generated.",
  "switchToFullTunnel": "Switch to full tunnel",
  "switchToSplitTunnel": "Switch to split tunnel",
  "fullTunnelRoutesALLOfEachEnrolledUserSTraffic": "Full tunnel routes ALL of each enrolled user's traffic through the gateway.",
  "splitTunnelRoutesOnlyTheGatewaySSubnetsOtherTraffic": "Split tunnel routes only the gateway's subnets; other traffic uses the user's own connection.",
  "thisRotatesEveryEnrolledUserSKeypairTheyMustRe": "This rotates every enrolled user's keypair. They must re-download their config after the switch.",
  "applyMode": "Apply mode",
  "serverGateway": "Server Gateway",
  "provisionPerUserWireGuardTunnelsIntoThisServer": "Provision per-user WireGuard tunnels into this server.",
  "tunnelMode": "Tunnel mode",
  "wireGuardTunnelMode": "WireGuard tunnel mode",
  "reApplyGateway": "Re-apply gateway",
  "enableGateway": "Enable gateway",
  "enrollAUser": "Enroll a user",
  "username": "username",
  "usernameToEnroll": "Username to enroll",
  "enroll": "Enroll",
  "usernamesAreLowercaseLettersDigitsUnderscoreAndHyphen": "Usernames are lowercase letters, digits, underscore, and hyphen.",
  "enrolledPeers": "Enrolled peers",
  "loadingPeers2": "Loading peers…",
  "noUsersEnrolledYetEnrollAUserAboveToGenerate": "No users enrolled yet. Enroll a user above to generate their tunnel config.",
  "failedToLoadCountries": "Failed to load countries",
  "failedToLoadNordVPNCountries": "Failed to load NordVPN countries",
  "failedToStartConfigGeneration": "Failed to start config generation",
  "generationFailed": "Generation failed",
  "nordVPNConfigGenerationStarted": "NordVPN config generation started",
  "networkError": "Network error",
  "failedToLoadOpenVPNStatus": "Failed to load OpenVPN status",
  "failedToLoadOpenVPNClientConfigs": "Failed to load OpenVPN client configs",
  "uploadFailed": "Upload failed",
  "configUploadStarted": "Config upload started",
  "failedToUploadConfigs": "Failed to upload configs",
  "activationFailed": "Activation failed",
  "tunnelActivationStarted": "Tunnel activation started",
  "failedToActivateTunnel": "Failed to activate tunnel",
  "deactivationFailed": "Deactivation failed",
  "tunnelDeactivationStarted": "Tunnel deactivation started",
  "failedToDeactivateTunnel": "Failed to deactivate tunnel",
  "deletionFailed": "Deletion failed",
  "tunnelDeletionStarted": "Tunnel deletion started",
  "failedToDeleteTunnel": "Failed to delete tunnel",
  "failedToLoadOpenVPNConfigs": "Failed to load OpenVPN configs",
  "failedToLoadRoutableApps": "Failed to load routable apps",
  "cSRFTokenNotFound": "CSRF token not found",
  "failedToUpdateKillSwitch": "Failed to update kill switch",
  "youDonTHavePermissionToViewVPNPolicySettings": "You don't have permission to view VPN policy settings.",
  "failedToLoadVPNPolicySettings": "Failed to load VPN policy settings",
  "failedToUpdateSettings": "Failed to update settings",
  "failedToLoadConnectionHistory": "Failed to load connection history",
  "failedToFetchJobStatus": "Failed to fetch job status",
  "failedToLoadServerKeys": "Failed to load server keys",
  "configIsHealthy": "Config is healthy",
  "configIsAging": "Config is aging",
  "configAppearsStale": "Config appears stale",
  "configIsQuarantined": "Config is quarantined",
  "testCompleteNoPositiveSignal": "Test complete — no positive signal",
  "failedToActivatePeer": "Failed to activate peer",
  "peerActivationStarted": "Peer activation started",
  "failedToDeactivatePeer": "Failed to deactivate peer",
  "peerDeactivationStarted": "Peer deactivation started",
  "failedToDeletePeer": "Failed to delete peer",
  "peerDeletionStarted": "Peer deletion started",
  "failedToTestConfig": "Failed to test config",
  "configTestFailed": "Config test failed",
  "testComplete": "Test complete",
  "failedToLoadVPNPeers": "Failed to load VPN peers",
  "failedToLoadGatewayPeers": "Failed to load gateway peers",
  "failedToLoadWireGuardGateway": "Failed to load WireGuard gateway",
  "failedToEnableGateway": "Failed to enable gateway",
  "wireGuardGatewayEnabled": "WireGuard gateway enabled",
  "enrollmentFailed": "Enrollment failed",
  "theirWireGuardConfigIsReadyToDownload": "Their WireGuard config is ready to download.",
  "failedToEnrollUser": "Failed to enroll user",
  "revokeFailed": "Revoke failed",
  "failedToRevokeUser": "Failed to revoke user",
  "failedToSetTunnelMode": "Failed to set tunnel mode",
  "modeSavedEnableTheGatewayToApply": "Mode saved — enable the gateway to apply",
  "theGatewayIsnTProvisionedYetEnableItToPush": "The gateway isn't provisioned yet. Enable it to push the new mode.",
  "enrolledUsersMustReDownloadTheirConfigKeysWereRotated": "Enrolled users must re-download their config (keys were rotated).",
  "vPNControl": "VPN Control",
  "noVPNBackendIsInstalledInstallWireGuardOrOpenVPNFrom": "No VPN backend is installed. Install WireGuard or OpenVPN from Package Management to enable VPN control.",
  "packageManagement": "Package Management",
  "manageWireGuardVPNPeerConfigurationsActivationAndServerKeys": "Manage WireGuard VPN peer configurations, activation, and server keys.",
  "viewTheBuiltInOpenVPNServerStatusAndPerUser": "View the built-in OpenVPN server status and per-user client profiles.",
  "vPNBackend": "VPN backend",
  "deactivateVPNPeer": "Deactivate VPN Peer",
  "affectedAppTrafficWillFallBackToTheHostNetwork": "Affected app traffic will fall back to the host network.",
  "deletePeerConfig": "Delete Peer Config",
  "errorLoadingPeers": "Error loading peers",
  "uploadConfigFiles": "Upload Config Files",
  "addWireGuardConfPeerConfigurationFiles": "Add WireGuard .conf peer configuration files",
  "activeConnection": "Active Connection",
  "currentlyActiveVPNPeer": "Currently active VPN peer",
  "activeConnections": "Active connections",
  "peers": "Peers",
  "mostUsed": "Most used:",
  "lastSwitch": "Last switch:",
  "history": "History",
  "serverKeypair": "Server Keypair",
  "peerConfigurations": "Peer Configurations",
  "wireGuardPeerConfigFiles": "WireGuard peer config files",
  "wireGuardCanAlsoBeManagedViaTheQuickBoxCLI": "WireGuard can also be managed via the QuickBox CLI:",
  "fullWireGuardDocumentation": "Full WireGuard documentation",
  "viewConfig2": "View {{name}} config",
  "deactivate2": "Deactivate {{name}}",
  "activate2": "Activate {{name}}",
  "delete": "Delete",
  "viewProfile": "View {{username}} profile",
  "downloadProfileBundle": "Download {{username}} profile bundle",
  "thisConfigIsAlreadyRoutingEachAppScopedRouteNeeds": "This config is already routing {{label}}. Each app-scoped route needs its own tunnel config.",
  "killSwitchThresholdMustBeBetweenAndSeconds": "Kill-switch threshold must be between {{KILL_SWITCH_THRESHOLD_MIN_SECS}} and {{KILL_SWITCH_THRESHOLD_MAX_SECS}} seconds.",
  "thisPeerConfigIsAlreadyRoutingEachAppScopedRoute": "This peer config is already routing {{label}}. Each app-scoped route needs its own WireGuard config.",
  "routeTrafficThroughWireGuard": "Route {{supportedAppsOr}} traffic through WireGuard",
  "level": "{{username}} (level {{userLevel}})",
  "whenTheVPNTunnelHandshakeIsStaleForMoreThan": "When the VPN tunnel handshake is stale for more than {{ksThreshold}}s, the service will be fully stopped. No traffic will flow until an admin manually re-enables routing.",
  "installToEnableRouting": "Install {{label}} to enable routing",
  "mustBeBetweenAnd": "Must be between {{min}} and {{max}}.",
  "copyConfigToClipboard": "Copy {{peerName}} config to clipboard",
  "isNotAFile": "{{name}} is not a {{acceptExtension}} file",
  "exceeds3MBLimit": "{{name}} exceeds 3MB limit",
  "maximumFilesAllowedOnlyTheFirstWillBeKept": "Maximum {{MAX_FILES}} files allowed. Only the first {{MAX_FILES2}} will be kept.",
  "dropZoneForConfigFilesMaximumFiles3MBEach": "Drop zone for {{kindLabel}} config files. Maximum {{MAX_FILES}} files, 3MB each.",
  "dropFilesHere": "Drop {{acceptExtension}} files here",
  "dragAndDropFiles": "Drag and drop {{kindLabel}} {{acceptExtension}} files",
  "selectConfigFiles": "Select {{kindLabel}} config files",
  "remove": "Remove {{name}}",
  "inUseByAppRouting": "In use by app routing: {{value1}}",
  "message": "{{value1}} {{name}}",
  "isNotAConfFile": "{{name}} is not a .conf file",
  "maximumFilesAllowedOnlyTheFirstWillBeKept2": "Maximum {{UPLOAD_MAX_FILES}} files allowed. Only the first {{UPLOAD_MAX_FILES2}} will be kept.",
  "maximumFilesAllowed": "Maximum {{UPLOAD_MAX_FILES}} files allowed.",
  "uploadWireGuardConfigFilesDragAndDropOrClickTo": "Upload WireGuard config files. Drag and drop or click to browse. Maximum {{UPLOAD_MAX_FILES}} files, 3MB each.",
  "viewDetailsFor": "View details for {{name}}",
  "hide": "Hide",
  "reveal": "Reveal",
  "copy2": "Copy {{label}}",
  "generatingConfigsFor": "Generating configs for {{country}}",
  "activating": "Activating {{name}}",
  "deactivating2": "Deactivating {{name}}",
  "deleting": "Deleting {{name}}",
  "userNotFound": "User \"{{username}}\" not found",
  "enrolled": "Enrolled {{username}}",
  "revoked": "Revoked {{username}}",
  "systemVPN2": "System VPN ({{name}})",
  "connectionOf": "Connection {{value1}} of {{length}}",
  "configsCount_one": "{{count}} config",
  "configsCount_other": "{{count}} configs",
  "uploadingConfigs_one": "Uploading {{count}} config",
  "uploadingConfigs_other": "Uploading {{count}} configs",
  "entriesCount_one": "{{count}} entry",
  "entriesCount_other": "{{count}} entries",
  "countriesCount_one": "{{count}} country available",
  "countriesCount_other": "{{count}} countries available",
  "deactivateRoutes_one": "Deactivating {{name}} will disable {{count}} app routing profile:",
  "deactivateRoutes_other": "Deactivating {{name}} will disable {{count}} app routing profiles:",
  "disableRoutes_one": "This will also disable {{count}} app routing profile:",
  "disableRoutes_other": "This will also disable {{count}} app routing profiles:",
  "connect": "Connect",
  "disconnect": "Disconnect",
  "pageOf": "Page {{page}} of {{totalPages}}",
  "routingApp": "routing {{app}}",
  "mainVpnInUse": "in use by main VPN",
  "routeTraffic": "Traffic from {{app}} ({{username}}) will be routed through this VPN config. Other system traffic remains unchanged.",
  "thresholdHelp": "Auto-failback if the WireGuard handshake stalls for this long. Leave blank to use the {{app}} default ({{duration}}). Range: {{min}}–{{max}}.",
  "stagedApp": "VPN routing is staged. {{app}} will use this tunnel automatically on its first install.",
  "installAppPackage": "Install {{app}} from Package Management to activate.",
  "killSwitchDefault": "Kill-switch auto-failback threshold. Default for {{app}}: {{duration}}.",
  "durationRange": "Range: {{min}}–{{max}}.",
  "defaultForApp": "Default for {{app}}: {{duration}}.",
  "required": "Required.",
  "uploadOpenvpnHelp": "Upload an {{extension}} client config to dial an outbound OpenVPN tunnel from this server.",
  "createProfileHelp": "Profiles are created per user by the installer. Run {{command}} to generate one.",
  "plexSetupHelp": "During first-time setup: use {{address}} to reach the setup wizard. Plex's TLS certificate isn't ready yet — HTTPS won't connect.",
  "plexReadyHelp": "After setup: Plex provisions its certificate automatically. Once ready, the normal {{protocol}} link works — no action needed.",
  "recoveryAttempt": "Attempt {{attempt}} of 5 completed. Next attempt at {{time}}.",
  "browseUploadHelp": "or click to browse — max {{count}} files, 3MB each",
  "selectedFilesCount": "Selected Files ({{count}})",
  "fileSizeCaption": "({{size}})",
  "activeAppRoute": "App routing active: {{app}} ({{username}}) via {{config}}",
  "moreMarkers": "+{{count}} more",
  "nordvpnHelp": "Generate WireGuard configuration files for NordVPN servers. Requires a NordVPN access token from {{account}} (Manual Setup > Generate Token).",
  "defaultDns": "Default: NordVPN DNS ({{dns}})",
  "probedAt": "Probed {{time}}",
  "confUploadHelp": ".conf files only — max {{count}} files, 3MB each",
  "deleteTunnelConfirm": "Are you sure you want to delete {{name}}? This stops the tunnel if active and removes the config from the system and stash.",
  "revokeGatewayConfirm": "Revoke {{username}}'s WireGuard gateway access? Their tunnel will stop and their config will no longer connect.",
  "deletePeerConfirm": "Are you sure you want to delete {{name}}? This will remove the config file and stop the interface if active.",
  "fullTunnelSaved": "Tunnel mode set to full tunnel",
  "splitTunnelSaved": "Tunnel mode set to split tunnel",
  "routingStatus": "{{app}} routing: {{status}}",
  "routingStatusError": "{{app}} routing: {{status}} — {{error}}",
  "save": "Save",
  "cancelling": "Cancelling...",
  "disabling": "Disabling...",
  "savingEllipsis": "Saving…",
  "testing": "Testing…",
  "collapse": "Collapse",
  "uploadCount": "Upload ({{count}})",
  "locationsCount_one": "{{count}} Location",
  "locationsCount_other": "{{count}} Locations",
  "themeMap": "Theme map",
  "darkMap": "Dark map",
  "lightMap": "Light map",
  "streetMap": "Street map",
  "satelliteMap": "Satellite map",
  "themeMapHelp": "Matches the dashboard theme",
  "deleteNamed": "Delete {{name}}",
  "hideNamed": "Hide {{label}}",
  "revealNamed": "Reveal {{label}}",
  "enrolledPeersCount": "Enrolled peers ({{count}})",
  "backendAdminRequired": "Admin privileges required",
  "backendInternalError": "Internal server error",
  "backendWireguardNotInstalled": "WireGuard is not installed",
  "backendKeysFailed": "Failed to read server keys",
  "backendPeerNameInvalid": "Invalid peer name format",
  "backendPeerConfigMissing": "Peer config not found",
  "backendVpnBusy": "A VPN operation is already in progress (job {{jobId}}: {{action}} {{peerName}}). Please wait for it to complete.",
  "backendMultipartRequired": "Expected multipart/form-data",
  "backendConfOnly": "Only .conf files accepted: {{filename}}",
  "backendFilenameInvalid": "Invalid config filename: {{filename}}",
  "backendFileTooLarge": "File too large: {{filename}} (max 3MB)",
  "backendFileEmpty": "Empty file: {{filename}}",
  "backendFilesMissing": "No files provided",
  "backendFilesLimit": "Too many files (max {{limit}})",
  "backendWireguardDirectory": "Cannot write to WireGuard config directory. Check filesystem permissions on /etc/v4-dashboard/wg.",
  "backendUploading": "Uploading {{length}} config(s)",
  "backendActivating": "Activating peer \"{{name}}\"",
  "backendDeactivating": "Deactivating peer \"{{name}}\"",
  "backendDeleting": "Deleting peer \"{{name}}\"",
  "backendJobIdInvalid": "Invalid job ID",
  "backendJobMissing": "Job not found",
  "backendPaginationInvalid": "Invalid pagination parameters",
  "backendCountriesFailed": "Failed to fetch NordVPN country list",
  "backendGeneratingNordvpn": "Generating NordVPN configs for {{country}} (limit: {{limit}})",
  "backendConfigNameInvalid": "Invalid config name format",
  "backendOpenvpnConfigMissing": "OpenVPN config '{{name}}' not found",
  "backendOpenvpnBusy": "An OpenVPN operation is already in progress (job {{jobId}}: {{action}} {{configName}}).",
  "backendUsernameInvalid": "Invalid username format",
  "backendProfileMissing": "Profile not found",
  "backendConfigMissing": "Config not found",
  "backendOvpnOnly": "Only .ovpn files accepted: {{filename}}",
  "backendOpenvpnDirectory": "Cannot write to OpenVPN config directory. Check permissions on /etc/v4-dashboard/openvpn.",
  "backendPermissionRequired": "VPN management permission required",
  "backendCsrfInvalid": "Invalid CSRF token",
  "backendModeInvalid": "mode must be 'split' or 'full'",
  "backendUserMissing": "Target user not found",
  "backendPackageMissing": "VPN package definition unavailable",
  "backendAppInvalid": "Invalid app ID",
  "backendUsernameRequired": "username query parameter required",
  "backendRoutingMissing": "No routing profile found",
  "backendGatewayProvisionFailed": "Failed to provision the WireGuard gateway",
  "backendPeerEnrollFailed": "Failed to enroll the WireGuard peer",
  "backendPeerRevokeFailed": "Failed to revoke the WireGuard peer",
  "backendAppUnsupported": "App '{{appId}}' is not supported for app-scoped routing",
  "backendRoutingConfigMissing": "{{label}} config '{{wgConfigName}}' not found",
  "backendMainConfigInUse": "This peer config is currently in use by your main VPN connection. App-scoped routing must use a different WireGuard config.",
  "backendOtherAppConfig": "This config is already routing {{otherLabel}}. Each app-scoped route needs its own {{label}} config.",
  "backendSharedTunnelMismatch": "{{label}} is already routed through the config '{{configName}}' for another account. Accounts share one tunnel per app; use that config or disable the other account's routing first.",
  "backendSystemServiceOwned": "{{detail}} is a system-wide service. Routing is already enabled by user '{{username}}'. Disable their routing first.",
  "backendDelugeConfigNeedsUpdate": "Deluge still pins a network interface in its daemon config, which fails inside the VPN routing namespace. Update Deluge first (its config migrates on update), then enable routing.",
  "backendTransmissionConfigNeedsUpdate": "Transmission's RPC whitelist does not allow the routing subnet (10.200.*.*), so it would reject clients once routed. Update Transmission first, then enable routing.",
  "backendUserRoutingMissing": "No routing profile found for this app and user",
  "backendStageDemoUnavailable": "stageAppRouting is not available in demo mode",
  "backendStagePlexOnly": "Pre-install VPN staging is only supported for Plex. Enable routing for '{{detail}}' after installation using the standard enable flow.",
  "backendSystemStageOwned": "{{detail}} is a system-wide service. Routing is already staged/enabled by user '{{username}}'. Disable their routing first.",
  "backendOvpnServerDirective": "This .ovpn appears to be an OpenVPN SERVER config (or is not a valid client config). App-routing and client management require a client config that dials into an upstream VPN provider. Reason: Config declares '{{detail}}', which puts OpenVPN in SERVER mode.",
  "backendOvpnServerMode": "This .ovpn appears to be an OpenVPN SERVER config (or is not a valid client config). App-routing and client management require a client config that dials into an upstream VPN provider. Reason: Config declares 'mode server'. VPN client configs dial out; they do not run a server.",
  "backendOvpnRemoteMissing": "This .ovpn appears to be an OpenVPN SERVER config (or is not a valid client config). App-routing and client management require a client config that dials into an upstream VPN provider. Reason: Config has no '{{directive}}' directive — a VPN client must declare the upstream provider endpoint to dial.",
  "backendOvpnDeviceMissing": "This .ovpn appears to be an OpenVPN SERVER config (or is not a valid client config). App-routing and client management require a client config that dials into an upstream VPN provider. Reason: Config has no 'dev tun' / 'dev tap' directive — it is missing the tunnel device declaration.",
  "backendOvpnReadFailed": "This .ovpn appears to be an OpenVPN SERVER config (or is not a valid client config). App-routing and client management require a client config that dials into an upstream VPN provider. Reason: Could not read .ovpn config at {{path}}.",
  "backendWgListenPort": "This config appears to be a WireGuard SERVER config, not a VPN client config. App-routing requires a client config that dials into an upstream VPN provider. Reason: Config has [Interface] ListenPort set, indicating it accepts incoming WireGuard connections (server-style). VPN client configs do not declare a ListenPort.",
  "backendWgMasquerade": "This config appears to be a WireGuard SERVER config, not a VPN client config. App-routing requires a client config that dials into an upstream VPN provider. Reason: [Interface] PostUp contains MASQUERADE on interface '{{iface}}' — this is a WireGuard SERVER config pattern (NAT-ing peer traffic to the host's physical interface). Client configs do not use MASQUERADE.",
  "backendWgEndpointMissing": "This config appears to be a WireGuard SERVER config, not a VPN client config. App-routing requires a client config that dials into an upstream VPN provider. Reason: Config has a [Peer] with no Endpoint, indicating it represents a dialing-in client (server-style). VPN client configs declare an Endpoint pointing at the upstream VPN provider.",
  "backendWgLocalEndpoint": "This config appears to be a WireGuard SERVER config, not a VPN client config. App-routing requires a client config that dials into an upstream VPN provider. Reason: [Peer] Endpoint '{{endpointHost}}' resolves to {{resolvedIp}}, which is this host's own public IP. The config points to a local WireGuard server rather than an upstream VPN provider.",
  "backendNordvpnApiStatus": "NordVPN API returned {{status}}",
  "backendNordvpnRetryExhausted": "NordVPN API did not return servers for {{country}} after {{attempts}} attempts — this is usually a transient hiccup, try again shortly",
  "backendNordvpnServersUnavailable": "No WireGuard servers are currently available for {{country}}",
  "backendNordvpnTokenInvalid": "Invalid NordVPN token. Please check your token and try again.",
  "backendNordvpnCredentialsStatus": "NordVPN credentials API returned {{status}}",
  "backendNordvpnKeyMissing": "Invalid NordVPN token. No NordLynx private key returned.",
  "backendProbeStashRead": "could not read config stash",
  "backendProbeConfigMissing": "config not found in stash",
  "backendProbeActive": "config is currently active — ephemeral probe skipped to avoid disturbing the live tunnel; fleet cross-check used",
  "backendSubnetAllocateFailed": "vpnAppSubnetService: failed to allocate octet for '{{appId}}' after {{attempts}} attempts — exhausted retries",
  "backendSubnetExhausted": "vpnAppSubnetService: no free octets in range [{{minimum}}, {{maximum}}] — all 254 subnets allocated",
  "backendRegisterFailed": "Failed to register: {{detail}}",
  "backendCountryServersMissing": "No WireGuard servers found for {{country}}",
  "backendConfigsNotCreated": "No configs were created successfully",
  "backendJobActionFailed": "{{action}} failed",
  "backendAborted": "Aborted by user",
  "backendTeeFailed": "sudo tee failed (exit {{code}}): {{detail}}",
  "backendTeeTimeout": "sudo tee timed out after {{CMD_TIMEOUT}}ms",
  "backendCatFailed": "sudo cat failed (exit {{code}}): {{detail}}",
  "backendCatTimeout": "sudo cat timed out after {{CMD_TIMEOUT}}ms",
  "backendNamespaceCreateFailed": "Failed to create namespace {{nsName}} - sudo command may have been denied",
  "backendNamespaceDirectoryFailed": "Failed to create /etc/netns directory for namespace {{nsName}}: {{detail}}",
  "backendWgReadFailed": "Failed to read WireGuard config: {{stashPath}}",
  "backendWgAddressMissing": "Could not parse Address from WireGuard config",
  "backendWgTempFailed": "Failed to write temp WireGuard config: {{error}}",
  "backendWgInterfaceMissing": "WireGuard interface {{wgInterface}} not up in namespace {{nsName}} after configuration",
  "backendOvpnInterfaceMissing": "OpenVPN tun interface did not appear in namespace {{nsName}} after starting {{unit}}. The .ovpn may be invalid or the upstream provider unreachable.",
  "backendLocalnetFailed": "Failed to enable route_localnet on {{vethNs}} in namespace {{nsName}}: {{detail}}",
  "backendDefaultInterfaceMissing": "Could not determine host default interface from `ip route show default` within {{timeoutMs}}ms ({{attempts}} attempts) — default route not yet programmed",
  "backendPublicAddressMissing": "Could not determine public IPv4 for interface {{iface}}",
  "backendPlexPreferencesFailed": "Failed to read Plex Preferences.xml at {{prefsPath}}: {{detail}}",
  "backendPlexCertificateMissing": "CertificateUUID not found in {{prefsPath}} — Plex may not have been claimed yet",
  "backendDropinCreateFailed": "Failed to create drop-in {{dropinPath}} - sudo command may have been denied",
  "backendDropinRemoveFailed": "Failed to remove drop-in {{dropinPath}} - service will be stuck in restart loop",
  "backendOvpnConfigRequired": "OpenVPN backend requires opts.tunnelConfigName",
  "backendNamespaceUnusable": "Namespace {{nsName}} exists but is not usable from the host mount namespace. This may indicate the namespace bind-mount was created in an isolated mount namespace.",
  "backendInvalidBodyDetails": "Invalid request body: {{message}}",
  "backendInvalidBody": "Invalid request body",
  "backendInvalidRequest": "Invalid request",
  "backendRequired": "{{field}}: A value is required",
  "backendExpectedString": "{{field}}: A text value is required",
  "backendExpectedNumber": "{{field}}: A number is required",
  "backendExpectedBoolean": "{{field}}: A boolean value is required",
  "backendExpectedObject": "{{field}}: An object is required",
  "backendExpectedInteger": "{{field}}: A whole number is required",
  "backendMinLength": "{{field}}: Minimum length: {{bound}}",
  "backendMaxLength": "{{field}}: Maximum length: {{bound}}",
  "backendMinimum": "{{field}}: Minimum value: {{bound}}",
  "backendMaximum": "{{field}}: Maximum value: {{bound}}",
  "backendFormat": "{{field}}: Invalid format",
  "backendChoice": "{{field}}: Choose one of: {{options}}",
  "backendOvpnActivating": "Activate config \"{{name}}\"",
  "backendOvpnDeactivating": "Deactivate config \"{{name}}\"",
  "backendOvpnDeleting": "Delete config \"{{name}}\"",
  "backendGeneratingProfile": "Generating OpenVPN config for {{username}}",
  "backendRegeneratingProfile": "Regenerating OpenVPN config for {{username}}",
  "backendProbeFailed": "probe failed — recorded unknown",
  "backendProbeCompleted": "handshake completed",
  "backendProbeNoHandshake": "no handshake within probe window — recorded unknown",
  "backendJobExit": "{{action}} failed with exit code {{exit}}",
  "backendTokenValidationFailed": "Token validation failed",
  "backendServersFailed": "Failed to fetch servers",
  "backendGenerationUnexpected": "Unexpected error during generation",
  "backendPrivateKeyFailed": "Failed to retrieve private key",
  "backendActionActivate": "Activation",
  "backendActionDeactivate": "Deactivation",
  "backendActionDelete": "Deletion",
  "backendActionUpload": "Upload",
  "backendActionGenerate": "NordVPN generation",
  "backendAutoFailback": "Auto-failback: WireGuard handshake stale ({{age}}s, threshold {{threshold}}s)",
  "backendKillSwitch": "Kill switch triggered: WireGuard handshake stale ({{age}}s, threshold {{threshold}}s). Service fully stopped.",
  "backendRecoveryExhausted": "Auto-recovery exhausted after {{attempts}} attempts. Last failure: {{detail}}",
  "backendRecoveryRetry": "Recovery attempt {{attempt}}/{{attempts}} failed: {{detail}}. Next attempt in {{minutes}}m.",
  "backendRecoveryEnableFailed": "enableAppRouting failed: {{detail}}",
  "backendRecoveryEnableError": "enableAppRouting error: {{detail}}",
  "backendRecoveryEnableUnknown": "enableAppRouting error: Unknown",
  "backendRecoveryHealthFailed": "Health check failed after re-enable",
  "backendHealthNoCountry": "no country in config",
  "backendHealthFleetFailed": "fleet fetch failed",
  "backendProbeBringupFailed": "probe bring-up failed",
  "backendReconcileMissing": "Boot-persistence unit \"{{unit}}\" is not installed on this server. App routing will NOT survive a reboot until it is installed (run \"qb update\" to pull the latest QuickBox system files).",
  "backendPortForwardStaticOnly": "A forwarded port can only be set for a static provider config (for example AirVPN).",
  "backendPortForwardRange": "Forwarded port must be between {{min}} and {{max}}.",
  "backendPortForwardRequired": "This provider assigns a port in your account. Enter the forwarded port to enable routing.",
  "backendProviderInvalid": "Invalid provider. Expected nordvpn, protonvpn, airvpn or unknown.",
  "portForwarding": "Port forwarding",
  "portForwardNone": "This VPN provider does not forward ports. Downloading, seeding and your tracker ratio all keep working. Your tracker may show you as not connectable, which only means other peers can't start a connection to you.",
  "portForwardOpenvpn": "Port forwarding needs the WireGuard backend. Over OpenVPN, downloading, seeding and your tracker ratio all keep working. Your tracker may show you as not connectable.",
  "portForwardNatpmpPending": "This provider leases a forwarded port automatically once routing is enabled.",
  "forwardedPortLabel": "Forwarded port (from your provider account)",
  "forwardedPortHelp": "Enter the port assigned in your provider account. It is required to enable routing for this provider.",
  "forwardedPortField": "Forwarded port",
  "portForwardStatusActive": "Active",
  "portForwardStatusRenewing": "Renewing",
  "portForwardStatusFailed": "Failed",
  "portForwardStatusStatic": "Static",
  "portForwardLeaseTooltip": "NAT-PMP lease, renewed automatically. Expires {{when}}.",
  "portForwardLeaseNoExpiry": "NAT-PMP lease, renewed automatically.",
  "portForwardRenewingHelp": "Waiting for the first forwarded port from your provider.",
  "portForwardFailedHelp": "Port forwarding failed. Downloading, seeding and your tracker ratio keep working; other peers can't start a connection to you until a port is leased again.",
  "providerOverride": "Provider override",
  "providerOverrideHelp": "Override the detected provider for an uploaded config the auto-detector misses. This sets whether the config forwards a port.",
  "providerOptionUnknown": "Unknown",
  "providerOverrideSaved": "Provider updated.",
  "providerOverrideFailed": "Failed to update provider."
} as const;
